import Tooltip from './Tooltip'

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/tooltip/index.js